<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FKC7OO/OEBPS/images/9780312316433_cvi.png?1726444398178" alt="This image is the cover for the book Royal Panoply"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Royal Panoply
      </h1>
      <p class="bookDescription body article font2">
        <p>From medieval conqueror to Renaissance autocrat to Victorian Empress to modern melodrama, <i>Royal Panoply</i> is the story of some of the most fascinating people in world history.<br/><br/>With her trademark blend of probing scholarship, lively prose, and psychological insight, Carolly Erickson focuses on each monarch's entire life---from the puny, socially awkward Charles I, to the choleric, violent William the Conqueror, to the well-meaning, deeply affectionate Queen Anne, who was so heavy she had to be carried to her coronation. <i>Royal Panoply</i> recaptures the event-filled, often dangerous, always engaging lives of England's kings and queens, set against the backdrop of a thousand years of Britain's past.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolly Erickson
      </h2>
      
      <p class="authorDescription body article"><P>Distinguished historian Carolly Erickson is the author of <I>The First Elizabeth</I><I>,</I><I>Great Catherine</I><I>,</I><I>Alexandra,</I> and a dozen other prize-winning biographies. She lives in Hawaii.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?647257cf